import { redirectDocument, redirect } from 'react-router-dom';
import { axiosInstance } from '@libs/axios/axios';
import { getAuthState } from '@shared/auth/AuthContext';
import { validatePaymentRedirect } from '@features/checkout/paymentRedirect';

export const RETURN_TRIAL_PATH = '/hairdresser/return-trial';
export const returnTrialAttemptKey = (userId: string) => `returnTrialAttempt:${userId}`;

export async function returnTrialLoader() {
  const { token, isDemo, user } = getAuthState();
  if (!token || isDemo || !user?.sub) {
    return redirect('/hairdresser');
  }
  sessionStorage.setItem(returnTrialAttemptKey(user.sub), '1');
  const { data } = await axiosInstance.post('/api/checkout/init', {
    planId: 'expert',
    billingCycle: 'MONTHLY',
    currency: 'CZK',
    source: 'return-trial',
  });
  return redirectDocument(validatePaymentRedirect(data.redirect));
}
